const WIDTH_SP = 768;

(() => {

  // 初期化処理
  const init = () => {
    const body = document.querySelector('body');
    body.style.opacity = "1";
    body.classList.remove('preload');

    // 各初期化関数の呼び出し
    initSmoothScroll();
    initIsOn();
    doFade();
    initSlider();
    initReviewMoreBtn();
    initFaq();
    initFixedCta();
  };

  // リサイズイベント処理
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initTextStroke();
    }, 200);
  };

  // スクロールイベント処理
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      doFade();
      initIsOn();
      lastScrollTime = now;
    }
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  document.addEventListener('scroll', handleScroll);
  
})();


// スムーススクロール
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const targetId = trigger.getAttribute('href').replace('#', '');
      const targetElement = document.getElementById(targetId);
      if (targetElement) adjustScrollPosition(targetElement, 'smooth');
    });
  });
};

const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const gap = document.getElementById('header')?.clientHeight || 0 + 80;
  const target = rect + offset - gap;

  window.scrollTo({ top: target, behavior });
};

// スクロールでis-onクラスを付与
const initIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-on');
    }
  });
};

// 要素のフェード
const doFade = () => {
  document.querySelectorAll('.js-fade-in').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > WIDTH_SP ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// スライダーのセット
const initSlider = () => {

  // 製品-製品サムネイル
  const prodThumbnail = new Swiper('.prod-thumbnail', {
    slidesPerView: 4.02,
    spaceBetween: "0.5%",
    freeMode: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      751: {
        slidesPerView: 5.03
      }
    }
  });
  const prodSwiper = new Swiper('.prod-slider', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: prodThumbnail
    }
  });

  // review
  setReviewModalSlides();

  // User Voice
  const updateVoiceCounter = (swiper) => {
    const isPC = window.innerWidth >= 751;
    const total = isPC
      ? Math.ceil(swiper.slides.length / 4)
      : swiper.slides.length;

    const current = isPC
      ? Math.floor(swiper.activeIndex / 4) + 1
      : swiper.activeIndex + 1;

    document.getElementById("voiceSwiperIndex").textContent = current;
    document.getElementById("voiceSwiperTotal").textContent = total;
  };

  const voiceSwiper = new Swiper(".voice-slide", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 18,
    navigation: {
      nextEl: ".voice-next",
      prevEl: ".voice-prev",
    },
    on: {
      init: function () {
        updateVoiceCounter(this);
      },
      slideChange: function () {
        updateVoiceCounter(this);
      },
    },
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        slidesPerGroup: 1,
      },
      751: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      }
    }
  });

};

// review もっと見るボタン
const initReviewMoreBtn = () => {

  const moreBtn = document.querySelector(".review__more");
  const listBoxes = document.querySelectorAll(".review__list-box");
  let currentVisible = 1;

  moreBtn.addEventListener("click", () => {
    if (currentVisible < listBoxes.length) {
      listBoxes[currentVisible].style.display = "flex";
      currentVisible++;
      if (currentVisible === listBoxes.length) {
        moreBtn.style.display = "none";
      }
    }
  });
}

// review モーダルのスライダー作成
function setReviewModalSlides() {
  const modal = document.getElementById("reviewModal");
  const swiperWrapper = modal.querySelector(".swiper-wrapper");
  const reviewItems = document.querySelectorAll(".review__list .review__item");

  // 一時的に表示
  modal.style.display = "flex";

  reviewItems.forEach((item) => {
    const clone = item.cloneNode(true);
  
    // onclickやリンク削除
    const linksToClean = clone.querySelectorAll("a");
    linksToClean.forEach(link => {
      if (link.getAttribute("onclick") === "setReviewModal();") {
        link.removeAttribute("onclick");
        link.removeAttribute("href");
      }
    });
  
    // ナビゲーションボタン削除（念のため）
    const navButtons = clone.querySelectorAll(".review-modal-next, .review-modal-prev");
    navButtons.forEach(btn => btn.remove());
  
    // クローンの中に「閉じる」ボタンを追加
    const closeBtn = document.createElement("a");
    closeBtn.href = "javascript:void(0);";
    closeBtn.setAttribute("onclick", "closeReviewModal()");
    closeBtn.className = "review-modal__close";
    closeBtn.textContent = "閉じる";
    clone.appendChild(closeBtn);
  
    // スライドとして追加
    const slide = document.createElement("div");
    slide.classList.add("swiper-slide");
    slide.appendChild(clone);
    swiperWrapper.appendChild(slide);
  });

  // swiper 初期化
  window.reviewSwiper = new Swiper("#reviewSwiper", {
    loop: false,
    slidesPerView: 1,
    speed: 300,
    centeredSlides: false,
    allowTouchMove: true,
    touchRatio: 1,
    mousewheelControl: true,
    mousewheelSensitivity: 0.5,
    navigation: {
      nextEl: ".review-modal-next",
      prevEl: ".review-modal-prev",
    },
    on: {
      slideChange: function () {
        updateReviewSwiperCounter(this);
      }
    }
  });

  // スライド数表示
  document.getElementById("reviewSwiperTotal").textContent = reviewItems.length;

  function updateReviewSwiperCounter(swiper) {
    document.getElementById("reviewSwiperIndex").textContent = swiper.realIndex + 1;
  }

  // 最初のカウンター
  updateReviewSwiperCounter(window.reviewSwiper);

  // モーダルを非表示
  modal.style.display = "none";
  document.querySelectorAll(".review__list .review__item").forEach((item, index) => {
    const link = item.querySelector("a");
    if (link) {
      link.onclick = () => {
        setReviewModal(index);
      };
    }
  });

  document.querySelectorAll(".review__list .review__item").forEach((item, index) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      setVoiceModal(index);
    });
  });

}

// モーダルの表示
function setReviewModal(index = 0) {
  const modal = document.querySelector(".review-modal");
  modal.style.display = "flex";

  // モーダル内のswiperを指定インデックスに移動（あれば）
  if (window.reviewSwiper) {
    window.reviewSwiper.slideTo(index);
  }
}

// モーダルを閉じる
function closeReviewModal() {
  const modal = document.querySelector(".review-modal");
  modal.style.display = "none";
}

// FAQ開閉 -------
const initFaq = () => {
  const moreBtn = Array.from(document.querySelectorAll('.faq-item-q'));

  moreBtn.forEach((item) => {
    item.addEventListener('click', function () {
      this.classList.toggle('is-on');
      const target = this.nextElementSibling;

      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + 'px';
      }
    });
  });
}

// Fixed CTA の表示切り替え
const initFixedCta = () => {
  const fixedCta = document.getElementById("fixed-cta");
  const product = document.getElementById("product");

  if (!fixedCta || !product) return;

  const toggleFixedCta = () => {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const productTop = product.getBoundingClientRect().top + scrollY;

    if (scrollY > productTop) {
      fixedCta.classList.add("show");
    } else {
      fixedCta.classList.remove("show");
    }
  };

  window.addEventListener("scroll", toggleFixedCta);
  toggleFixedCta(); // 初期化時にも呼び出す
};
